export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const SET_FACETS = 'SET_FACETS';
export const SET_APPLIED_REFINEMENTS = 'SET_APPLIED_REFINEMENTS';
export const SET_TITLE = 'SET_TITLE';
export const SET_PAGE_META_DATA = 'SET_PAGE_META_DATA';
export const TOGGLE_FILTER_MENU = 'TOGGLE_FILTER_MENU';
export const OPEN_FILTERS = 'OPEN_FILTERS';
export const CLOSE_FILTERS = 'CLOSE_FILTERS';
